import { render, staticRenderFns } from "./Selecoes.vue?vue&type=template&id=649cf4e6&scoped=true"
import script from "./Selecoes.vue?vue&type=script&lang=js"
export * from "./Selecoes.vue?vue&type=script&lang=js"
import style0 from "./Selecoes.vue?vue&type=style&index=0&id=649cf4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cf4e6",
  null
  
)

export default component.exports